import React, { useState, useEffect, useMemo } from "react";
import SavingsDataService from "./services/SavingsService";
import { useSelector } from 'react-redux';
import BeautifulTable from "../components/BeautifulTable";
import { fNumber } from "../utils/formatNumber";

const Savingss = (props) => {
  const [savings, setSavings] = useState([]);

  const { user: currentUser } = useSelector((state) => state.auth);
  const currentUserId = currentUser?.id;

  useEffect(() => {
    retrieveSavings();
  }, []); // eslint-disable-line

  const retrieveSavings = () => {
    SavingsDataService.getAll(currentUserId)
      .then((response) => setSavings(response.data ?? response))
      .catch((e) => console.error(e));
  };

  const columns = useMemo(
    () => [
      { Header: "Date", accessor: "date", Cell: ({ value }) => (value ? new Date(value).toLocaleDateString() : "") },
      { Header: "Amount", accessor: "amount", Cell: ({ value }) => (value != null && value !== "" ? fNumber(value) : "0.00") },
      { Header: "Transaction type", accessor: "creditOrDebit" },
      { Header: "Description", accessor: "description" },
      { Header: "New Balance", accessor: "newBalance", Cell: ({ value }) => (value != null && value !== "" ? fNumber(value) : "0.00") },
      { Header: "Posted Date", accessor: "createdAt", Cell: ({ value }) => (value ? new Date(value).toLocaleString() : "") }
    ],
    []
  );

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <BeautifulTable
          columns={columns}
          data={savings}
          pageSize={10}
          onRowClick={(row) => props.history?.push && props.history.push(`/dashboard/savings/${row.id || row._id}`)}
        />
      </div>
    </div>
  );
};

export default Savingss;
